<template>
  <div>
    <home-carousel />
    <div
      class="knews"
      :class="{ 'game-type': gameLobby }"
    >
      <div class="news-img">
        <img :src="$getThemeImagePath('bullhorn.svg')" alt="">
      </div>

      <div
        ref="marqueeContainer"
        class="news-body"
        @mouseenter="stopMarquee"
        @mouseleave="startMarquee"
      >
        <a v-for="(item, key) in marqueeDetails.filter(item => item.isShow)" :key="key" :style="marqueeStyle" @click="goNewsPage(key+1)">
          <span class="subtitle">
            {{ item.title }}
          </span>
        </a>
      </div>
      <a class="news-more" @click="goNewsPage('')">{{ $t('Bao.news_more') }}<i class="fa-solid fa-chevron-right" /></a>
    </div>

    <search-game v-if="isMobile()" id="search_game_modal_mb" :all-game="allGame" />
    <search-provider v-if="isMobile()" id="provider_game_modal_mb" @change-provider="changeGameProvider" />

    <div class="main-max-width">
      <div class="game-quick-link">
        <!-- 中間區塊-新事件 -->
        <div
          class="new-events"
          :class="{ 'game-type': gameLobby }"
        >
          <div class="game-title">
            <h2>{{ $t('Bao.new_event') }}</h2>
          </div>
          <div class="new-events-div">
            <div
              ref="carousel-event"
              class="list"
            >
              <div
                v-for="item in brandImage"
                :key="item.id"
                class="new-swiper-slide"
              >
                <a @click.prevent="handleClick(item.link,item.open_type)">
                  <img :src="item.image" alt="">
                </a>
              </div>
            </div>
            <div class="game-button-alpha">
              <div
                class="game-next fa-solid fa-angle-left "
                :class="{ disabled: !canScrollPrev('event') }"
                @click=" prev('event')"
              />
              <div
                class="game-prev fa-solid fa-angle-right "
                :class="{ disabled: !canScrollNext('event') }"
                @click=" next('event')"
              />
            </div>
          </div>
        </div>

        <!-- 點擊 All -->
        <div
          v-if="!isFirstRender && currentGameCategory || activeFilter === 'favorites' &&
            catagoryList && catagoryList.length > 0"
          ref="gameCategoryContainer"
          class="slider provider-container list"
        >
          <div ref="categoryContainer">
            <div
              v-for="(item, key) in catagoryList"
              :key="key"
              :class="{ active: isGameCategoryActive(item) }"
              @click="changeGameCategory(item)"
            >
              <a>
                <img :src="item.image_banner" alt="">
              </a>
            </div>
          </div>
        </div>

        <div class="lobby-search-bar" :class="{ 'game-type': !isFirstRender }">
          <div v-if="!isFirstRender" class="back-icon" @click="handleBack">
            <a><i class="fa-solid fa-chevron-left fa-lg" /></a>
          </div>
          <ul>
            <li @click="showSearchProvider()">
              <i>
                <img :src="$getThemeImagePath('icon-filter.png')" alt="">
              </i>
              <span>{{ $t("Bao.provider_name") }}</span>
            </li>
            <li class="search-box" @click="showSearchGame()">
              <div class="slot-animation">
                <span>{{ $t('Bao.search_games_text1') }}</span>
                <span id="workHour" class="font-weight-bold work_hour font-xl">0</span>
                <span>{{ $t('Bao.search_games_text2') }}</span>
              </div>
              <i class="fa-solid fa-magnifying-glass iconSearch" />
            </li>
          </ul>
        </div>
        <template v-if="isFirstRender">
          <div v-for="item in catagoryGame" :key="item.id" class="game-section">
            <div class="game-title">
              <a class="g-t-group" @click="showAllGame(item)">
                <h2>{{ item.name }}</h2>
                <div class="btn-to-allGames"><i class="fa-solid fa-angle-right" /></div>
              </a>
              <div class="game-bn">
                <i class="button-icon btn-game-bn-all" @click="showAllGame(item)">{{ $t('Bao.show_all') }}</i>
                <div class="button-icon angle-left">
                  <i
                    class="fa-solid fa-angle-left"
                    :class="{ disabled: !canScrollPrev(item.id) }"
                    @click=" prev(item.id)"
                  />
                </div>
                <div class="button-icon angle-right">
                  <i
                    class="fa-solid fa-angle-right"
                    :class="{ disabled: !canScrollNext(item.id) }"
                    @click=" next(item.id)"
                  />
                </div>
              </div>
            </div>
            <div :key="componentKey" class="game-card-list">
              <div
                :ref="item.id === -1 ? 'carousel-fav' : `carousel-${item.id}`"
                class="game-card-list-div"
              >
                <div
                  v-for="game in allCategoryGame[item.id]"
                  :key="game.id"
                  class="game-swiper-slide"
                >
                  <div
                    :class="{ 'active': hover === game.id }"
                    class="game-card"
                    :data-category="item.id"
                    @click="token ? handleLaunchGame(game) : hover = game.id"
                    @mouseenter="!isMobile() && !token && (hover = game.id)"
                    @mouseleave="!isMobile() && !token && (hover = null)"
                  >
                    <div v-if="game.brand_game_category_id.includes('HOT')" class="game-info-icon-hot">
                      HOT
                    </div>
                    <div v-if="game.brand_game_category_id.includes('NEW')" class="game-info-icon-new">
                      NEW
                    </div>
                    <div class="game-card-name">
                      <div class="game-tx">
                        <div class="game-name name-tex">
                          {{ game.name }}
                        </div>
                        <div class="game-provider">
                          <img :src="getProviderImage(game.game_provider_id)" alt="">
                          <span class="game-rtp">
                            <template v-if="game.rtp !== -1">
                              <p>{{ (game.rtp * 100).toFixed(2) }}%</p>
                            </template>
                          </span>
                        </div>
                      </div>
                      <div class="game-info">
                        <i class="game-info-icon" />
                        <i
                          v-if="token"
                          class="game-info-icon-heart-show"
                          :class="{ active:game.isFavorite }"
                          @click.stop="handleFavoriteGame(game)"
                        />
                        <i
                          v-if="game.brand_game_category_id.includes('NO BONUS')"
                          class="game-info-icon-nobonus-show"
                        />
                      </div>
                    </div>
                    <div class="game-card-image">
                      <div class="img-mask" />
                      <d-img :src="game" :alt="game.name" />
                    </div>

                    <div class="game-card-info">
                      <div class="game-info-bn">
                        <button @click.stop="handleLaunchGame(game)">
                          {{ $t("Bao.play_game_now") }}
                        </button>
                        <button v-if="game.demo_url" @click.stop="openDemoGame(game)">
                          {{ $t('Bao.demo') }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="game-button-alpha">
                  <div
                    class="game-next fa-solid fa-angle-left "
                    :class="{ disabled: !canScrollPrev(item.id) }"
                    @click=" prev(item.id)"
                  />
                  <div
                    class="game-prev fa-solid fa-angle-right "
                    :class="{ disabled: !canScrollNext(item.id) }"
                    @click=" next(item.id)"
                  />
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="game-main">
            <div class="game-section">
              <div class="game-title">
                <h1 v-if="activeFilter === 'favorites'">
                  {{ $t('Bao.my_favorite') }}
                </h1>
                <h1 v-else-if="currentGameCategory">
                  {{ currentGameCategory.name }}
                </h1>
                <h1 v-else-if="currentGameProvider">
                  {{ currentGameProvider.name }}
                </h1>
              </div>
              <div class="tabs-content">
                <div class="tab-inner">
                  <div class="game-card-list game-type">
                    <div
                      v-for="game in selectedCategoryGame"
                      :key="game.id"
                      class="game-card"
                      :class="{ 'active': hover === game.id }"
                      @click="token ? handleLaunchGame(game) : hover = game.id"
                      @mouseenter="!isMobile() && !token && (hover = game.id)"
                      @mouseleave="!isMobile() && !token && (hover = null)"
                    >
                      <div v-if="game.brand_game_category_id.includes('HOT')" class="game-info-icon-hot">
                        HOT
                      </div>
                      <div v-if="game.brand_game_category_id.includes('NEW')" class="game-info-icon-new">
                        NEW
                      </div>
                      <div class="game-card-name">
                        <div class="game-tx">
                          <div class="game-name name-tex">
                            {{ game.name }}
                          </div>
                          <div class="game-provider">
                            <img :src="getProviderImage(game.game_provider_id)" alt="">
                            <span class="game-rtp">
                              <template v-if="game.rtp !== -1">
                                <p>{{ (game.rtp * 100).toFixed(2) }}%</p>
                              </template>
                            </span>
                          </div>
                        </div>
                        <div class="game-info">
                          <i class="game-info-icon" />
                          <i
                            v-if="token"
                            class="game-info-icon-heart-show"
                            :class="{ active:game.isFavorite }"
                            @click.stop="handleFavoriteGame(game)"
                          />
                          <i
                            v-if="game.brand_game_category_id.includes('NO BONUS')"
                            class="game-info-icon-nobonus-show"
                          />
                        </div>
                      </div>
                      <div class="game-card-image">
                        <div class="img-mask" />
                        <d-img :src="game" :alt="game.name" />
                      </div>

                      <div class="game-card-info">
                        <div class="game-info-bn">
                          <button @click.stop="handleLaunchGame(game)">
                            {{ $t("Bao.play_game_now") }}
                          </button>
                          <button v-if="game.demo_url" @click.stop="openDemoGame(game)">
                            {{ $t('Bao.demo') }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <scroll-loader v-if="activeFilter === 'others'" :loader-method="getIndexGameList" :loader-disable="!enableAutoLoad" />
          </div>
        </template>
      </div>
    </div>
    <search-game v-if="!isMobile()" id="search_game_modal" :all-game="allGame" />
    <search-provider v-if="!isMobile()" id="provider_game_modal" @change-provider="changeGameProvider" />
    <iframe-game v-if="gameUrlFromStore" :key="gameComponentKey" :all-game="allGame" :text="gameTextTitle" />
    <before-game-open-modal :is-active="gameModalOpen" />
    <currency-selection-modal :is-visible="showCurrencyModal" @close="showCurrencyModal = false" />
  </div>
</template>

<script>
import { getGames, getGamesV2, getGameList, getProviderGame, getGameNum } from '@/api/game'
import { addFavoriteGame, removeFavoriteGame, updateToken, info } from '@/api/user'
import { getMarqueeDetail } from '@/api/brand'
import { getEventDetail } from '@/api/event'
import { showToast, detectMob, initializeCountUp, updateCountUp } from '@/utils/tool'
import { gameEnd, launchGameWithProviderInfo } from '@/utils/games'
import dImg from '@/components/dynamicImg'
import homeCarousel from '@/components/homeCarousel'
import beforeGameOpenModal from '@/components/modal/beforeGameOpenModal'
import iframeGame from '@/components/modal/iframeGame'
import searchProvider from '@/components/popup-box/searchProvider'
import searchGame from '@/components/popup-box/searchGame'
import currencySelectionModal from '@/components/modal/currencySelectionModal'
import { mapMutations, mapGetters } from 'vuex'
import ScrollLoader from 'vue-scroll-loader/src/components/Scroll-Loader'
import themeMixin from '@/mixins/themeMixin'

export default {
  name: 'Index',
  components: {
    beforeGameOpenModal,
    dImg,
    homeCarousel,
    searchProvider,
    searchGame,
    iframeGame,
    ScrollLoader,
    currencySelectionModal
  },
  mixins: [themeMixin],
  data() {
    return {
      navigationHistory: [],
      allGame: [],
      selectedCategoryGame: [],
      allCategoryGame: [],
      favoriteAll: [],
      marqueeDetails: [],
      positionX: 100,
      speed: 0.8,
      isRunning: false,
      animationFrameId: null,
      page: 1,
      page_size: 100, // 點擊 ALL 之後的遊戲數量
      game_size: 10, // 首頁遊戲數量
      isFirstRender: true,
      gameTextTitle: '',
      workHourVal: 0,
      hover: null,
      catagoryGame: [],
      catagoryList: [],
      allCategory: [],
      allProvider: [],
      allGameData: [],
      isFromBack: false,
      cardWidth: 193,
      actualGap: 16,
      componentKey: 0,
      isGameCategoryReady: false,
      enableAutoLoad: true,
      loading: false,
      showCurrencyModal: false,
      gameComponentKey: 0,
      providerImageMap: {}
    }
  },
  metaInfo() {
    const isProduction = process.env.VUE_APP_ENV === 'production'

    if (!this.isTheme('theme_gold')) {
      return {}
    }

    const metaByType = {
      recommend: {
        title: '勝WINオンラインカジノおすすめゲーム！katsuwin',
        description: '勝WINでオンラインカジノおすすめゲームを楽しもう！',
        keywords: 'オンカジおすすめ,オンラインカジノおすすめ',
        gameTypeNumber: isProduction ? 29 : 84
      },
      new: {
        title: '勝WIN最新ゲーム｜オンカジスロット・パチンコ・パチスロ',
        description: '勝WIN最新ゲーム｜新作オンカジ・パチンコ・パチスロを楽しもう',
        keywords: 'スロットゲーム,スロット,ライブカジノ,パチンコ新台,パチンスロ新台',
        gameTypeNumber: isProduction ? 1 : 102
      },
      popular: {
        title: '勝WINオンラインカジノ人気ゲーム｜注目のオンカジ・パチンコ・パチスロ',
        description: '勝WIN人気ゲーム｜オンカジ・パチンコ・パチスロの人気タイトルを一目でチェック',
        keywords: 'オンカジ, 人気ゲーム, オンラインカジノ, 勝WIN, パチンコ, パチスロ, スロット',
        gameTypeNumber: isProduction ? 30 : 101
      },
      slot: {
        title: '勝WIN｜高RTPスロット＆ジャックポット付き人気ゲームを楽しもう',
        description: '勝WINで豊富なスロットゲームを楽しもう！高RTPやジャックポット付きのスロットが揃っており、ボーナスを活用して大当たりを狙えます。',
        keywords: 'スロットゲーム,スロット',
        gameTypeNumber: isProduction ? 13 : 100
      },
      live_casino: {
        title: '勝WIN｜ライブカジノでリアルな臨場感を体験しよう',
        description: '勝WINでライブカジノをプレイ！ブラックジャックやバカラ、ルーレットでリアルな臨場感を楽しもう。',
        keywords: 'ライブカジノ',
        gameTypeNumber: isProduction ? 12 : 87
      },
      pachislot: {
        title: '勝WIN｜人気パチスロゲームを楽しもう',
        description: '勝WINパチスロ｜人気ゲームで大当たりを狙おう',
        keywords: 'パチスロ',
        gameTypeNumber: isProduction ? 2 : 85
      },
      pachinko: {
        title: '勝WIN｜パチンコ人気ゲームを楽しもう',
        description: '勝WINパチンコ｜人気ゲームをまとめて楽しもう',
        keywords: 'パチンコ',
        gameTypeNumber: isProduction ? 14 : 97
      },
      crash: {
        title: 'クラッシュゲーム｜パチンコ人気ゲームを楽しもう',
        description: '勝WINパチンコ｜クラッシュゲームを楽しもう',
        keywords: 'クラッシュゲーム',
        gameTypeNumber: isProduction ? 6 : 86
      }
    }

    const gameCategoryId = this.currentGameCategory ? this.currentGameCategory.id : null
    const meta = Object.values(metaByType).find(m => m.gameTypeNumber === gameCategoryId)

    if (gameCategoryId && meta) {
      return {
        title: meta.title,
        meta: [
          { name: 'description', content: meta.description },
          { name: 'keywords', content: meta.keywords }
        ]
      }
    }

    return {
      title: 'アジアNo.1オンラインパチンコ・パチスロ『勝WIN』へようこそ  | 日本人プレイヤーのためのオンカジおすすめゲーム',
      meta: [
        { name: 'description', content: 'オンラインカジノ・オンカジおすすめなら勝WIN！日本人向けに特化した最新オンラインパチンコ・パチスロ・ライブカジノを楽しめるサイト。お得なボーナスやプロモーションも充実し、原則申請から1時間以内の出金に対応。' },
        { name: 'keywords', content: 'オンラインカジノ,オンカジ,勝WIN,katsuwin' }
      ]
    }
  },
  computed: {
    ...mapGetters(['token', 'user', 'brand', 'game', 'gameProvider', 'app', 'permissionInfo']),
    brandImage() {
      const brandImage = this.brand.brandImage.img_event
      return Array.isArray(brandImage)
        ? [...brandImage].sort((a, b) => a.sort - b.sort)
        : []
    },
    gameCategory() {
      const category = Array.isArray(this.$store.getters.gameCategory)
        ? this.$store.getters.gameCategory.slice()
        : []

      return [...category].sort((a, b) => a.sorting - b.sorting)
    },
    activeFilter() {
      return this.user.activeFilter
    },
    gameModalOpen() {
      return this.app.isModalActive
    },
    gameUrlFromStore() {
      return this.app.gameUrl
    },
    currentGameCategory() {
      return this.user.currentGameCategory
    },
    currentGameProvider() {
      return this.user.currentGameProvider
    },
    marqueeStyle() {
      return {
        transform: `translateX(${this.positionX}px)`
      }
    },
    favoriteGamesId() {
      return this.user.favoriteGame || []
    },
    gameLobby() {
      return this.brand.showSearch || this.brand.showProvider ||
      this.currentGameCategory || this.currentGameProvider ||
      this.activeFilter === 'favorites'
    }
  },
  watch: {
    'gameCategory': {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.allCategory = newVal
          this.buildProviderImageMap()
          this.isGameCategoryReady = true
          this.checkAndInitialize()
        }
      }
    },
    'activeFilter'(to) {
      if (to === 'others' && !this.currentGameCategory && !this.currentGameProvider) {
        this.initIndex()
      } else if (to === 'favorites') {
        this.isFirstRender = false
        this.updateFavoriteAll(this.favoriteGamesId)

        this.$nextTick(() => {
          this.gameScroll('gameCategoryContainer')
        })
      }
    },
    'currentGameCategory'(to) {
      if (to !== null) {
        this.isFirstRender = false
        this.$store.commit('SET_ACTIVE_FILTER', 'others')
        this.getCatagoryList()
        this.queryGame()

        const category = this.allCategory.find(c => c.seo_path === to.seo_path)
        if (category && category.seo_path !== '') {
          // 如果目前網址沒有正確參數，就補上
          if (this.$route.params.seo_path !== category.seo_path) {
            this.$router.replace({ params: { seo_path: category.seo_path }})
          }
        }

        if (this.game.gameNum === 0) {
          this.getGameNum()
        } else {
          this.updateWorkHour(this.game.gameNum)
        }

        if (this.allProvider.length === 0) {
          this.getAllProvider()
        }

        this.$nextTick(() => {
          setTimeout(() => {
            this.clearQuery()
            this.gameScroll('gameCategoryContainer')
          }, 300)
        })
      } else if (to === null && !this.currentGameProvider) {
        if (this.activeFilter !== 'favorites') {
          this.initIndex()
        }
      }
    },
    'currentGameProvider'(to) {
      if (to !== null) {
        this.isFirstRender = false
        this.queryGame()

        if (this.game.gameNum === 0) {
          this.getGameNum()
        } else {
          this.updateWorkHour(this.game.gameNum)
        }

        this.$nextTick(() => {
          setTimeout(() => {
            this.clearQuery()
            this.gameScroll()
          }, 300)
        })
      } else {
        if (this.activeFilter !== 'favorites' && !this.currentGameCategory) {
          this.initIndex()
        }
      }
    },
    'gameUrlFromStore'(newVal, oldVal) {
      if (!newVal && oldVal) {
        gameEnd(this.app.inGameId)
        this.$store.commit('SET_PENDING_GAME_DATA', null)
        info().then(response => {
          const walletInfo = response.data.data.walletInfo
          this.$store.commit('SET_WALLET_INFO', walletInfo)

          const selectedWallet = walletInfo.find(wallet => wallet.wallet_type === this.app.selectedWallet.wallet_type)
          this.$store.commit('SET_SELECTED_WALLET', selectedWallet)
        }).catch(error => {
          console.error('Failed to refresh wallet data:', error)
        })
      }
    },
    'token'(newVal, oldVal) {
      this.initIndex()
      this.hover = null
    },
    '$store.state.app.pendingGameData'(newVal) {
      this.showCurrencyModal = !!newVal && !this.$store.state.app.gameUrl
    },
    '$store.state.app.isCurrencyChangeInProgress'(newVal, oldVal) {
      // When currency change starts, increment the key to force component re-mount
      if (newVal && !oldVal) {
        this.gameComponentKey++
        console.log('Forcing iframe-game component re-mount with key:', this.gameComponentKey)
      }
    }
  },
  beforeDestroy() {
    this.stopMarquee()
  },
  created() {
    if (this.user.isFromChampionship && !this.token) {
      this.$store.commit('SET_LOGIN_OPEN', true)
    }
    this.$store.commit('SET_CHAMPIONSHIP', false)
    if (this.user.isFromPromotion && !this.token) {
      this.$store.commit('SET_LOGIN_OPEN', true)
    }
    this.$store.commit('SET_PROMOTION', false)

    if (localStorage.getItem('fromSelfRestraint')) {
      this.$store.commit('SET_LOGIN_OPEN', true)
      localStorage.removeItem('fromSelfRestraint')
    }

    getMarqueeDetail().then(response => {
      this.marqueeDetails = response.data.data
      const userVipLevel = this.$store.state.user.memberInfo ? this.$store.state.user.memberInfo.vip_level_id : null
      const userMemberLevel = this.$store.state.user.memberInfo ? this.$store.state.user.memberInfo.vl : null
      this.marqueeDetails.forEach(item => {
        item.isShow = false
        if (!item.setting || !item.setting.allow_vip_levels || !item.setting.allow_member_levels) {
          item.isShow = true
          this.$store.commit('SET_MARQUEE_DETAIL', null)
          return
        }
        const allowedVipLevels = item.setting.allow_vip_levels
          .split(',')
          .map(s => s.trim())
          .filter(s => s)
          .map(Number)

        const allowedMemberLevels = item.setting.allow_member_levels
          .split(',')
          .map(s => s.trim())
          .filter(s => s)
          .map(Number)

        if (allowedVipLevels.includes(userVipLevel) &&
        allowedMemberLevels.includes(userMemberLevel)) {
          item.isShow = true
        }
        this.$store.commit('SET_MARQUEE_DETAIL', this.marqueeDetails)
      })

      if (this.user.newsId) {
        getEventDetail(this.user.newsId)
          .then(response => {
            const newsCount = response.data.data.reward.count
            const gameText = this.marqueeDetails.find(item => {
              return item.catalog === 'manual_first_deposit_v2'
            })

            if (newsCount > 0 && gameText) {
              this.gameTextTitle = gameText.title
            }
          })
      }

      this.$nextTick(() => {
        this.startMarquee()
      })
    })

    this.checkTokenExpiration()
    this.getAllGameForSearch()
  },
  mounted() {
    this.initializeCountUp()
  },
  methods: {
    checkAndInitialize() {
      if (this.isGameCategoryReady && this.allCategory && this.allCategory.length > 0) {
        this.isInit()
      }
    },
    isInit() {
      // 從別的頁面回到首頁
      if (this.currentGameCategory) {
        if (localStorage.getItem('onlyOneGame')) {
          this.$store.commit('SET_CURRENT_GAME_CATEGORY', null)
          localStorage.removeItem('onlyOneGame')

          if (this.$route.params.seo_path) {
            this.$router.replace('/')
          }
        } else {
          this.isFirstRender = false
          this.$store.commit('SET_ACTIVE_FILTER', 'others')
          this.getCatagoryList()
          this.queryGame()
          this.getGameNum()
          this.getAllProvider()

          this.$nextTick(() => {
            setTimeout(() => {
              this.gameScroll('gameCategoryContainer')
            }, 300)
          })
        }
      } else if (this.currentGameProvider) {
        if (localStorage.getItem('onlyOneGame')) {
          this.$store.commit('SET_CURRENT_GAME_PROVIDER', null)
          localStorage.removeItem('onlyOneGame')
        } else {
          this.isFirstRender = false
          this.queryGame()
          this.getGameNum()
          this.getAllProvider()
        }

        this.$store.commit('SET_ACTIVE_FILTER', 'others')
      } else if (this.activeFilter === 'favorites') {
        this.isFirstRender = false

        this.getCatagoryList()
        this.updateFavoriteAll(this.favoriteGamesId)

        this.$nextTick(() => {
          this.gameScroll('gameCategoryContainer')
        })
      } else {
        this.initIndex()
      }
    },
    getAllProvider() {
      getProviderGame().then((response) => {
        this.allProvider = response.data.data
        this.allProvider.sort((a, b) => a.sort - b.sort)
        this.$store.commit('SET_GAME_PROVIDER', this.allProvider)
      })
    },
    handleQuery(queryKey, storeKey, source) {
      const queryValue = Number(this.$route.query[queryKey])
      const item = source.find(item => item.id === queryValue || item.game_type === queryValue)

      if (item) {
        this.$store.commit(storeKey, item)
      } else {
        this.clearQuery()
        this.initIndex()
      }
    },
    setQueryObj(query) {
      if (query.category) {
        this.$nextTick(() => {
          setTimeout(() => {
            this.handleQuery('category', 'SET_CURRENT_GAME_CATEGORY', this.gameCategory)
          }, 1000)
        })
      } else if (query.provider_id) {
        if (!this.gameProvider) {
          this.getAllProvider()
          this.$nextTick(() => {
            setTimeout(() => {
              this.handleQuery('provider_id', 'SET_CURRENT_GAME_PROVIDER', this.gameProvider)
            }, 1000)
          })
        } else {
          this.handleQuery('provider_id', 'SET_CURRENT_GAME_PROVIDER', this.gameProvider)
        }
      } else if (query.share_code) {
        this.$store.commit('SET_REGISTER_OPEN', true)
        this.isFirstRender = true
        this.getIndexGameList()
      } else {
        this.clearQuery()
        this.initIndex()
      }
    },
    setCategoryObj(seo_path) {
      const category = this.allCategory.find(c => c.seo_path === seo_path)
      if (category) {
        this.$store.commit('SET_CURRENT_GAME_CATEGORY', category)
      } else {
        this.$router.replace('/')
        this.initIndex()
      }
    },
    initIndex() {
      const query = this.$route.query
      const hasParams = Object.keys(query).length > 0
      if (hasParams) {
        this.isFirstRender = false
        this.setQueryObj(query)
        return
      } else if (localStorage.getItem('fromLandingPageRegister')) {
        if (!this.token) {
          this.$store.commit('SET_REGISTER_OPEN', true)
        }

        localStorage.removeItem('fromLandingPageRegister')
        this.isFirstRender = true
        this.getIndexGameList()
        return
      }

      const seo_path = this.$route.params.seo_path
      if (seo_path) {
        this.isFirstRender = false
        this.setCategoryObj(seo_path)
        return
      }

      this.isFirstRender = true
      this.navigationHistory = []
      this.isFromBack = false

      this.$store.commit('SET_SHOW_RESEARCH', false)
      this.$store.commit('SET_SHOW_PROVIDER', false)

      this.getIndexGameList()

      this.$store.commit('SET_ACTIVE_FILTER', 'others')
      this.$store.commit('SET_CURRENT_GAME_CATEGORY', null)
      this.$store.commit('SET_CURRENT_GAME_PROVIDER', null)

      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      })

      this.resetScrollToStart('-1')
      this.allCategory.forEach(category => {
        this.resetScrollToStart(category.id)
      })

      this.componentKey += 1
    },
    handleBack() {
      if (this.navigationHistory.length > 0) {
        this.navigationHistory.pop()
        this.isFromBack = true

        const lastHistory = this.navigationHistory[this.navigationHistory.length - 1]
        if (!lastHistory) {
          this.initIndex()
        } else if (lastHistory.attribute === 'category') {
          this.$store.commit('SET_CURRENT_GAME_CATEGORY', lastHistory)
          this.$store.commit('SET_CURRENT_GAME_PROVIDER', null)
        } else if (lastHistory.attribute === 'provider') {
          this.$store.commit('SET_CURRENT_GAME_PROVIDER', lastHistory)
          this.$store.commit('SET_CURRENT_GAME_CATEGORY', null)
        } else {
          this.$store.commit('SET_ACTIVE_FILTER', 'favorites')
          this.$store.commit('SET_CURRENT_GAME_CATEGORY', null)
          this.$store.commit('SET_CURRENT_GAME_PROVIDER', null)
        }
      } else {
        if (this.activeFilter !== 'favorites') {
          this.initIndex()
        }
      }
    },
    queryGame() {
      this.allGameData = []
      this.selectedCategoryGame = []
      this.page = 1
      this.enableAutoLoad = true
      this.hover = null
      this.getIndexGameList()
    },
    async getIndexGameList() {
      this.$meta().refresh()
      this.$store.commit('SET_GAME_READY', false)

      if (!this.isFirstRender) {
        if (this.loading) return
        this.loading = true

        if (!this.currentGameCategory && !this.currentGameProvider) {
          this.loading = false

          setTimeout(() => {
            if (this.currentGameCategory || this.currentGameProvider) {
              this.getIndexGameList()
            }
          }, 100)
          return
        }

        let id = ''
        let queryObj = {}

        if (this.currentGameCategory) {
          id = this.currentGameCategory.id
          queryObj =
          {
            category: id,
            page: this.page,
            page_size: this.page_size
          }

          if (this.isFromBack) {
            this.isFromBack = false
          } else {
            this.navigationHistory.push(this.currentGameCategory)
          }
        } else if (this.currentGameProvider) {
          id = this.currentGameProvider.id
          queryObj =
          {
            provider_id: id,
            page: this.page,
            page_size: this.page_size
          }

          if (this.isFromBack) {
            this.isFromBack = false
          } else {
            this.navigationHistory.push(this.currentGameProvider)
          }
        }

        const gamesData = await this.fetchGamesFromAPI(queryObj)
        if (gamesData.list.length === 0) {
          this.loading = false
          this.enableAutoLoad = false
          this.$store.commit('SET_GAME_READY', true)
          return
        }

        this.allGameData = [...this.allGameData, ...gamesData.list]
        const processedGames = this.sortCategoryGames(gamesData.list)
        this.selectedCategoryGame = [...this.selectedCategoryGame, ...processedGames]

        if (this.allGameData.length === 1 && this.token) {
          localStorage.setItem('onlyOneGame', true)

          this.handleLaunchGame(processedGames[0])
          this.enableAutoLoad = false
        } else if (this.allGameData.length >= gamesData.page_info.total_count) {
          this.enableAutoLoad = false
        } else {
          this.page += 1
          this.enableAutoLoad = true
        }

        this.loading = false
        this.$store.commit('SET_GAME_READY', true)
      } else {
        this.getAllProvider()

        try {
          this.$store.commit('SET_LOADING_COUNT_PLUS', true)

          const categories = this.allCategory
          if (!categories || !Array.isArray(categories) || categories.length === 0) {
            console.error('無有效的遊戲分類資料')
            return
          }

          this.getCatagoryGame()

          const results = await this.fetchAllCategoryGames(categories)

          // 將結果整理成物件形式
          const groupedGames = {}
          results.forEach(result => {
            groupedGames[result.categoryId] = result.games
          })

          if (this.favoriteGamesId.length > 0) {
            await this.updateFavoriteAll(this.favoriteGamesId)

            const groupedFavoriteGames = {
              '-1': this.favoriteAll
            }

            this.allCategoryGame = {
              ...this.sortAllCategoryGames(groupedGames),
              ...groupedFavoriteGames
            }

            this.getCatagoryList()
          } else {
            this.allCategoryGame = this.sortAllCategoryGames(groupedGames)
          }

          this.$store.commit('SET_GAME_READY', true)

          this.getGameNum()
        } catch (error) {
          console.error('獲取遊戲資料錯誤:', error)
        } finally {
          this.$store.commit('SET_LOADING_COUNT_ZERO', true)
        }
      }
    },
    // 處理滾動加載觸發
    onScrollLoaderTriggered() {
      if (this.enableAutoLoad && !this.loading) {
        this.loadMoreGames()
      }
    },
    sortCategoryGames(gamesData) {
      return gamesData
        .filter(game => this.isActiveGame(game))
        .sort(this.sortGames)
        .map(game => {
          return {
            ...game,
            isFavorite: this.isGameFavorite(game.id)
          }
        })
    },
    sortAllCategoryGames(gamesObj) {
      const result = {}
      Object.keys(gamesObj).forEach(categoryId => {
        result[categoryId] = gamesObj[categoryId]
          .filter(game => this.isActiveGame(game))
          .sort(this.sortGames)
          .map(game => {
            return {
              ...game,
              isFavorite: this.isGameFavorite(game.id)
            }
          })
      })
      return result
    },
    sortGames(a, b) {
      const aHasNew = a.brand_game_category_id.includes('NEW')
      const bHasNew = b.brand_game_category_id.includes('NEW')
      const aHasHot = a.brand_game_category_id.includes('HOT')
      const bHasHot = b.brand_game_category_id.includes('HOT')

      // Prioritize 'NEW' over 'HOT'
      if (aHasNew && !bHasNew) {
        return -1 // 'NEW' comes first
      }
      if (!aHasNew && bHasNew) {
        return 1 // 'NEW' comes first
      }

      // Prioritize 'HOT' if neither has 'NEW'
      if (aHasHot && !bHasHot) {
        return -1 // 'HOT' comes first
      }
      if (!aHasHot && bHasHot) {
        return 1 // 'HOT' comes first
      }

      // Fallback to sorting by recommend_sort
      return a.recommend_sort - b.recommend_sort
    },
    showAllGame(game) {
      if (!this.game.isGameReady) return

      this.isFirstRender = false
      this.allGameData = []
      this.selectedCategoryGame = []

      if (game.id === -1) {
        this.$store.commit('SET_ACTIVE_FILTER', 'favorites')
      } else {
        game.attribute = 'category'
        this.$store.commit('SET_CURRENT_GAME_CATEGORY', game)
      }

      this.$nextTick(() => {
        this.gameScroll('gameCategoryContainer')
      })
    },
    getCatagoryList() {
      if (this.token && (this.favoriteAll.length > 0)) {
        const customItem = {
          image_banner: this.$getThemeImagePath('icon_tab_favorite.png'),
          isFavGame: true
        }
        this.catagoryList = [customItem, ...this.gameCategory]
      } else {
        this.catagoryList = this.gameCategory
      }
    },
    getCatagoryGame() {
      if (this.token && this.favoriteGamesId.length > 0) {
        const updatedCategory = [...this.gameCategory]
        const customItem = {
          id: -1,
          name: this.$t('Bao.my_favorite')
        }
        updatedCategory.unshift(customItem)
        this.catagoryGame = updatedCategory
      } else {
        this.catagoryGame = this.gameCategory
      }
    },
    prev(categoryId) {
      if (categoryId === 'category') {
        const container = this.$refs.categoryContainer
        if (!container) return

        const firstChild = container.firstElementChild
        const itemWidth = firstChild ? firstChild.offsetWidth : 0
        const gap = 16 // Same as CSS gap
        const scrollAmount = itemWidth + gap

        container.scrollBy({
          left: -scrollAmount,
          behavior: 'smooth'
        })
      } else {
        let container = ''
        let cardWidth = ''

        if (categoryId !== 'event') {
          const key = categoryId < 0 ? 'fav' : categoryId.toString()
          container = this.$refs[`carousel-${key}`]
          cardWidth = this.cardWidth
        } else {
          container = this.$refs['carousel-event']
          cardWidth = 290
        }

        const element = Array.isArray(container) ? container[0] : container
        if (!element) return false
        const scrollStep = cardWidth + this.actualGap

        element.scrollTo({
          left: element.scrollLeft - scrollStep,
          behavior: 'smooth'
        })
      }
    },
    next(categoryId) {
      if (categoryId === 'category') {
        const container = this.$refs.categoryContainer
        if (!container) return

        const firstChild = container.firstElementChild
        const itemWidth = firstChild ? firstChild.offsetWidth : 0
        const gap = 16 // Same as CSS gap
        const scrollAmount = itemWidth + gap

        container.scrollBy({
          left: scrollAmount,
          behavior: 'smooth'
        })
      } else {
        let container = ''
        let cardWidth = ''

        if (categoryId !== 'event') {
          const key = categoryId < 0 ? 'fav' : categoryId.toString()
          container = this.$refs[`carousel-${key}`]
          cardWidth = this.cardWidth
        } else {
          container = this.$refs['carousel-event']
          cardWidth = 290
        }

        const element = Array.isArray(container) ? container[0] : container
        if (!element) return false
        const scrollStep = cardWidth + this.actualGap

        element.scrollTo({
          left: element.scrollLeft + scrollStep,
          behavior: 'smooth'
        })
      }
    },
    canScrollPrev(categoryId) {
      if (categoryId === 'category') {
        const container = this.$refs.categoryContainer
        return container ? container.scrollLeft > 0 : false
      }
      let container = ''
      if (categoryId !== 'event') {
        const key = categoryId < 0 ? 'fav' : categoryId.toString()
        container = this.$refs[`carousel-${key}`]
      } else {
        container = this.$refs['carousel-event']
      }

      const element = Array.isArray(container) ? container[0] : container
      if (!element) return false
      return element.scrollLeft > 0
    },
    canScrollNext(categoryId) {
      if (categoryId === 'category') {
        const container = this.$refs.categoryContainer
        return container ? container.scrollLeft < (container.scrollWidth - container.clientWidth) : false
      }
      let container = ''
      if (categoryId !== 'event') {
        const key = categoryId < 0 ? 'fav' : categoryId.toString()
        container = this.$refs[`carousel-${key}`]
      } else {
        container = this.$refs['carousel-event']
      }

      const element = Array.isArray(container) ? container[0] : container
      if (!element) return false
      return element.scrollLeft < (element.scrollWidth - element.clientWidth)
    },
    // 滾動到第一筆
    resetScrollToStart(categoryId) {
      const key = categoryId < 0 ? 'fav' : categoryId.toString()
      const container = this.$refs[`carousel-${key}`]
      const element = Array.isArray(container) ? container[0] : container
      if (!element) return

      element.scrollTo({
        left: 0,
        behavior: 'smooth'
      })
    },
    isGameFavorite(gameId) {
      return this.favoriteGamesId.some(fav => fav.game_id === gameId)
    },
    checkGameLength(currentGames) {
      if (!Array.isArray(currentGames)) return false

      const validGames = currentGames.filter(game => this.isActiveGame(game))

      // 直接返回是否有足够的有效游戏
      return validGames.length >= this.game_size
    },
    async fetchAllCategoryGames(categories) {
      const categoryIds = categories.map(category => category.id)
      const responses = await getGamesV2({
        category: JSON.stringify(categoryIds),
        page: 1,
        page_size: this.game_size
      })

      if (!responses || !responses.data || !responses.data.data) {
        console.error('No valid response from API')
        return []
      }

      // 初始处理每个类别的数据
      const initialResults = categoryIds.map(categoryId => {
        const response = responses.data.data[categoryId]
        const gamesList = response && response.list ? [...response.list] : []

        // 计算有效游戏数量
        const validGames = gamesList.filter(game => this.isActiveGame(game))

        return {
          categoryId,
          games: gamesList,
          // 检查有效游戏的数量是否足够
          hasEnoughGames: validGames.length >= this.game_size,
          pageInfo: response ? response.page_info : null,
          currentPage: 2 // 准备从第二页开始
        }
      })

      // 找出需要更多游戏的类别
      const categoriesNeedingMoreGames = initialResults.filter(
        result => !result.hasEnoughGames &&
             result.pageInfo &&
             result.currentPage <= result.pageInfo.page_count
      )

      // 当前页码，从第2页开始
      let currentPageNumber = 2

      // 如果有类别需要更多游戏
      while (categoriesNeedingMoreGames.length > 0) {
        // 收集当前页码需要请求的类别ID
        const idsToFetch = categoriesNeedingMoreGames
          .filter(category => category.currentPage === currentPageNumber)
          .map(category => category.categoryId)

        // 如果没有需要当前页码的类别，增加页码并继续
        if (idsToFetch.length === 0) {
          currentPageNumber++
          continue
        }

        // 请求当前页码的数据
        const additionalData = await getGamesV2({
          category: JSON.stringify(idsToFetch),
          page: currentPageNumber,
          page_size: this.game_size
        })

        if (!additionalData || !additionalData.data || !additionalData.data.data) {
          console.error(`页码 ${currentPageNumber} 的API返回无效数据`)
          break
        }

        // 处理每个类别的额外数据
        for (let i = categoriesNeedingMoreGames.length - 1; i >= 0; i--) {
          const category = categoriesNeedingMoreGames[i]

          // 只处理当前页码匹配的类别
          if (category.currentPage !== currentPageNumber) continue

          const newData = additionalData.data.data[category.categoryId]

          if (newData && newData.list && newData.list.length > 0) {
            // 计算新数据中的有效游戏数量
            newData.list.filter(game => this.isActiveGame(game))

            // 将新游戏添加到原始结果中
            const resultIndex = initialResults.findIndex(r => r.categoryId === category.categoryId)
            if (resultIndex !== -1) {
              // 添加新数据
              initialResults[resultIndex].games = [
                ...initialResults[resultIndex].games,
                ...newData.list
              ]

              // 检查是否有足够的有效游戏
              const validGames = initialResults[resultIndex].games.filter(g => this.isActiveGame(g))

              if (validGames.length >= this.game_size) {
                // 移除已经有足够游戏的类别
                categoriesNeedingMoreGames.splice(i, 1)
              } else {
                // 更新页数，准备请求下一页
                category.currentPage++
                if (category.currentPage > category.pageInfo.page_count) {
                  categoriesNeedingMoreGames.splice(i, 1)
                }
              }
            }
          } else {
            // 如果没有数据返回，从列表中移除
            categoriesNeedingMoreGames.splice(i, 1)
          }
        }

        // 增加页码，准备下一次请求
        currentPageNumber++

        // 如果所有类别都已处理完毕或页码超过最大值，退出循环
        if (categoriesNeedingMoreGames.length === 0 || currentPageNumber > 100) {
          break
        }
      }

      // 最终处理每个类别的游戏数据
      return initialResults.map(result => {
        // 过滤出有效游戏
        const validGames = result.games.filter(game => this.isActiveGame(game))

        const processedGames = validGames
          .slice(0, this.game_size)
          .sort(this.sortGames)
          .map(game => ({
            ...game,
            isFavorite: this.isGameFavorite(game.id)
          }))

        return { categoryId: result.categoryId, games: processedGames }
      })
    },
    buildProviderImageMap() {
      const map = {}
      for (const category of this.allCategory) {
        if (!category.providers) continue
        for (const provider of category.providers) {
          if (!map[provider.id]) {
            map[provider.id] = provider.sidebar_image_app
          }
        }
      }
      this.providerImageMap = map
    },
    getProviderImage(providerId) {
      return this.providerImageMap[providerId] || ''
    },
    startMarquee() {
      if (this.isRunning) return
      this.isRunning = true

      const moveText = () => {
        if (!this.isRunning) return
        this.positionX -= this.speed

        if (this.positionX <= -this.$refs.marqueeContainer.scrollWidth) {
          this.positionX = this.$refs.marqueeContainer.offsetWidth
        }

        this.animationFrameId = requestAnimationFrame(moveText)
      }

      moveText()
    },
    stopMarquee() {
      this.isRunning = false
      cancelAnimationFrame(this.animationFrameId)
    },
    goNewsPage(key) {
      if (key) {
        this.$store.commit('SET_CHOOSE_NEWS', key)
      }
      this.$router.push({ path: '/user/news' })
    },
    // 被選中的遊戲標籤要移動至畫面中
    scrollToActive(refName) {
      this.$nextTick(() => {
        if (refName === 'gameCategoryContainer') {
          const container = this.$refs.gameCategoryContainer
          const activeItem = container.querySelector('.active')

          if (activeItem) {
            const containerRect = container.getBoundingClientRect()
            const activeItemRect = activeItem.getBoundingClientRect()

            // Calculate scroll position to center the active item
            const scrollPosition = activeItemRect.left - containerRect.left +
                                  container.scrollLeft -
                                  (containerRect.width / 2) +
                                  (activeItemRect.width / 2)

            container.scrollTo({
              left: scrollPosition,
              behavior: 'smooth'
            })
          }
        }
      })
    },
    gameScroll(refName) {
      this.scrollToActive(refName)
      this.$nextTick(() => {
        const activeElements = this.$refs[refName]

        if (!activeElements || activeElements === undefined) {
          let top = 450
          if (this.isMobile()) {
            top = 0
          }

          window.scrollTo({ top, behavior: 'smooth' })
        } else {
          const activeFilter = Array.isArray(activeElements)
            ? activeElements.find(el => el.classList.contains('active'))
            : activeElements

          if (activeFilter) {
            let offset = 30
            if (this.isMobile()) {
              offset = 120
            }
            const top = activeFilter.getBoundingClientRect().top + window.scrollY - offset
            window.scrollTo({ top, behavior: 'smooth' })
          }
        }
      })
    },
    updateWorkHour(newValue) {
      this.workHourVal = newValue

      this.$nextTick(() => {
        updateCountUp('workHour', newValue)
      })
    },
    isMobile() {
      return detectMob()
    },
    handleClick(banner_url, open_type) {
      if (banner_url === '/personal/data/modal') {
        this.$router.push(banner_url)
        return
      }

      let id = null
      const eventIdMatch = banner_url.match(/eventId=(\d+)/)

      if (eventIdMatch) {
        id = eventIdMatch[1]
      }

      switch (open_type) {
        case 'self':
          if (id) {
            // 有 eventId,導向 event 頁面
            this.$router.push({ path: '/event', query: { eventId: id }})
          } else {
            // 沒有 eventId,直接導向 link
            window.location.href = banner_url
          }
          break

        case 'iframe':
          this.$store.commit('SET_GAME_URL', banner_url)
          break

        case 'new':
          window.open(banner_url, '_blank')
          break

        default:
          if (id) {
            this.$router.push({ path: '/event', query: { eventId: id }})
          } else {
            window.location.href = banner_url
          }
      }
    },
    async handleFavoriteGame(game) {
      const gameInfo = {
        type: 'game',
        data: JSON.stringify([{
          brand_id: this.user.goldInfo.brand_id,
          game_id: game.id
        }])
      }
      try {
        const response = game.isFavorite
          ? await removeFavoriteGame(gameInfo)
          : await addFavoriteGame(gameInfo)

        this.$store.commit('SET_FAVORITE_GAME', response.data.data.game)
        this.showToast(game, !game.isFavorite)

        await this.updateFavoriteAll(this.favoriteGamesId)
        if (this.currentGameCategory || this.currentGameProvider) {
          this.selectedCategoryGame = this.sortCategoryGames(this.selectedCategoryGame)
        } else {
          const groupedFavoriteGames = {
            '-1': this.favoriteAll
          }
          this.allCategoryGame = {
            ...this.sortAllCategoryGames(this.allCategoryGame),
            ...groupedFavoriteGames
          }
          this.getCatagoryGame()
          this.resetScrollToStart('-1')
        }
      } catch (error) {
        console.error(error)
      }
    },
    showToast(game, isFavorite) {
      const message = isFavorite ? `${game.name} ${this.$t('Bao.favorite')}` : `${game.name} ${this.$t('Bao.favorite_remove')}`
      showToast(message)
      setTimeout(() => {
        this.$store.commit('SET_TOAST_MESSAGE', null)
      }, 3000)
    },
    async updateFavoriteAll(favorArr) {
      let gamesData = []
      const favoriteGameIds = new Set(favorArr.map(favGame => favGame.game_id))
      const gamesArr = Array.from(favoriteGameIds)
      await getGameList({ game_id_list_string: JSON.stringify(gamesArr) })
        .then((response) => {
          gamesData = response.data.data
        })
        .catch((err) => {
          console.log(err)
        })
      const processedGames = gamesData
        .filter(game => this.isActiveGame(game))
        .sort(this.sortGames)
        .map(game => {
          return {
            ...game,
            isFavorite: favoriteGameIds.has(game.id)
          }
        })

      this.favoriteAll = processedGames
      this.favoriteAll.attribute = 'favorites'

      if (this.activeFilter === 'favorites') {
        this.selectedCategoryGame = this.favoriteAll
      }

      this.getCatagoryList()

      if (this.isFirstRender) {
        return
      }

      if (this.isFromBack) {
        this.isFromBack = false
      } else {
        this.navigationHistory.push({ attribute: 'favorites' })
      }
    },
    initializeCountUp,
    getGameNum() {
      getGameNum().then((response) => {
        this.$store.commit('SET_GAME_NUM', response.data.num)
        this.updateWorkHour(response.data.num)
      })
        .catch((err) => {
          console.log(err)
        })
    },
    getGameSum(gameData) {
      var totalNum = gameData.reduce((sum, game) => sum + game.num, 0)
      return totalNum
    },
    async fetchGamesFromAPI(queryObj) {
      const response = await getGames(queryObj)
      return response.data.data || []
    },
    async handleLaunchGame(game) {
      await launchGameWithProviderInfo(game)
    },
    checkTokenExpiration() {
      setInterval(() => {
        if (localStorage.getItem('token')) {
          const expiredTime = localStorage.getItem('expired_time')
          if (!expiredTime || new Date().getTime() > expiredTime) {
            this.updateToken()
          }
        }
      }, 60000)
    },
    updateToken() {
      if (localStorage.getItem('token')) {
        updateToken({ token: localStorage.getItem('token') }).then(response => {
          const tokenData = response.data.data.token
          const expiredTime = new Date().getTime() + (tokenData.expired_interval * 1000)
          localStorage.setItem('expired_time', expiredTime)
          localStorage.setItem('token', tokenData.token)
        }).catch(error => {
          console.error('Error updating token', error)
        })
      }
    },
    async getAllGameForSearch() {
      const response = await getGames({ showLoading: false })
      this.allGame = response.data.data.list.filter(game => this.isActiveGame(game))

      this.$store.commit('SET_ALL_GAME', this.allGame)
    },
    isGameCategoryActive(item) {
      if (this.activeFilter === 'favorites' && item.isFavGame) return true
      // Check if the currently active filter matches the given category
      if (this.activeFilter === 'others' && this.currentGameCategory && this.currentGameCategory.id === item.id) {
        return true
      }
      return false
    },
    changeGameCategory(item) {
      if (!this.game.isGameReady) return

      if (this.$route.params.seo_path && item.seo_path !== this.$route.params.seo_path) {
        this.$router.replace('/')
      }

      const filterValue = item.isFavGame ? 'favorites' : 'others'

      if (filterValue === 'favorites') {
        this.$store.commit('SET_CURRENT_GAME_CATEGORY', null)
      } else {
        item.attribute = 'category'
        this.$store.commit('SET_CURRENT_GAME_CATEGORY', item)
      }

      this.$store.commit('SET_CURRENT_GAME_PROVIDER', null)
      this.$store.commit('SET_ACTIVE_FILTER', filterValue)
    },
    changeGameProvider(item) {
      if (!this.game.isGameReady) return

      if (this.$route.params.seo_path) {
        this.$router.replace('/')
      }

      this.$store.commit('SET_CURRENT_GAME_CATEGORY', null)

      item.attribute = 'provider'
      this.$store.commit('SET_CURRENT_GAME_PROVIDER', item)
      this.$store.commit('SET_ACTIVE_FILTER', 'others')
    },
    ...mapMutations(['SET_SHOW_RESEARCH', 'SET_SHOW_PROVIDER']),
    showSearchProvider() {
      this.$store.commit('SET_SHOW_PROVIDER', true)
      this.$store.commit('SET_SHOW_RESEARCH', false)
    },
    showSearchGame() {
      this.$store.commit('SET_SHOW_RESEARCH', true)
      this.$store.commit('SET_SHOW_PROVIDER', false)
    },
    openDemoGame(game) {
      this.$store.commit('SET_GAME_URL', game.demo_url)
    },
    clearQuery() {
      if (Object.keys(this.$route.query).length > 0) {
        this.$router.replace({ query: {}})
      }
    },
    isActiveGame(game) {
      return game.status === 1 && game.is_show === 1
    }
  }
}
</script>
